var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.7672 24.2937C78.1924 22.0063 72.8076 22.0063 68.2328 24.2937L36.75 40.0351V86.3474C36.75 90.6756 39.3633 96.4224 46.6123 103.88C53.1718 110.628 62.8274 118.058 75.513 126.264C88.3929 118.06 97.9902 111.47 104.524 105.15C111.441 98.4589 114.25 92.7204 114.25 86.3474V40.0351L82.7672 24.2937ZM126.75 36.1727V86.3474C126.75 97.2994 121.551 106.071 113.215 114.135C105.049 122.033 93.2432 129.859 78.8373 138.957C76.7987 140.244 74.2013 140.244 72.1627 138.957C57.5119 129.704 45.7817 120.959 37.649 112.592C29.6442 104.357 24.25 95.5941 24.25 86.3474V36.1724C24.25 33.805 25.5875 31.6409 27.7049 30.5822L62.6426 13.1133C70.7365 9.06639 80.2635 9.06638 88.3574 13.1133L123.295 30.5822C125.413 31.6409 126.75 33.8054 126.75 36.1727ZM98.6694 54.2529C101.11 56.6937 101.11 60.651 98.6694 63.0918L76.1694 85.5918C73.7287 88.0326 69.7714 88.0326 67.3306 85.5918L56.0806 74.3418C53.6398 71.901 53.6398 67.9437 56.0806 65.503C58.5214 63.0622 62.4786 63.0622 64.9194 65.5029L71.75 72.3335L89.8306 54.2529C92.2714 51.8122 96.2287 51.8122 98.6694 54.2529Z",
    fill: "#20A3BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheck);
export default __webpack_public_path__ + "static/media/shield-check.03c65e6541712a0dbdc8ce051fc3db4d.svg";
export { ForwardRef as ReactComponent };